import { render, staticRenderFns } from "./WasteVisualizationSimple.vue?vue&type=template&id=34657dd4&scoped=true&"
import script from "./WasteVisualizationSimple.vue?vue&type=script&lang=js&"
export * from "./WasteVisualizationSimple.vue?vue&type=script&lang=js&"
import style0 from "./WasteVisualizationSimple.vue?vue&type=style&index=0&id=34657dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34657dd4",
  null
  
)

export default component.exports